// @ts-strict-ignore
import {Component, contentChild, inject, Input, OnInit, TemplateRef} from "@angular/core";
import {TrackByMethods} from "@services";
import {Translations, TranslationToken} from "@translations";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {AssessableContextService} from "../services/assessment-context.service";
import {AssessablePanelMode, AssessablePanelType, UNGROUPED_ITEMS_GROUP_ID} from "@common/components/assessment/utils";
import {AssessableUiService} from "../services/assessable-ui.service";
import {AssessableItemTemplateContext, AssessableItemTemplateDirective} from "../assessable-item-template.directive";
import {AssessableItem} from "@models";

const localizationKeyPrefixMap = {
	[AssessablePanelType.Assessment]: "ASSESSMENT",
	[AssessablePanelType.Checklist]: "CHECKLIST",
} as const;

@Component({
	selector: "sim-assessable-group-panel",
	templateUrl: "./assessable-group-panel.component.html",
	styleUrls: ["./assessable-group-panel.component.scss"],
	animations: [zoomInOnEnterAnimation({duration: 250}), zoomOutOnLeaveAnimation({duration: 250})],
	standalone: false,
})
export class AssessableGroupPanelComponent<T extends AssessableItem> implements OnInit {
	// Enums
	protected readonly T = Translations;
	protected readonly TrackByMethods = TrackByMethods;
	protected readonly AssessablePanelMode = AssessablePanelMode;
	protected readonly AssessablePanelType = AssessablePanelType;
	protected readonly UNGROUPED_ITEMS_GROUP_ID = UNGROUPED_ITEMS_GROUP_ID;

	@Input() scoreTemplate: TemplateRef<any>;
	@Input() groupInEditModeId: string;
	@Input({required: true}) type: AssessablePanelType;

	protected itemTemplateRef = contentChild.required<AssessableItemTemplateDirective<T>, TemplateRef<AssessableItemTemplateContext<T>>>(
		AssessableItemTemplateDirective,
		{read: TemplateRef},
	);

	// injections
	protected store = inject(AssessableUiService);
	protected contextService = inject<AssessableContextService<T>>(AssessableContextService);

	// dynamic localization keys
	public groupsHeaderLocalizationKey: TranslationToken = "" as TranslationToken;
	public nonGroupedItemsHeaderLocalizationKey: TranslationToken = "" as TranslationToken;
	public addItemToGroupLocalizationKey: TranslationToken = "" as TranslationToken;

	public ngOnInit() {
		const prefix = localizationKeyPrefixMap[this.type];
		this.groupsHeaderLocalizationKey = `${prefix}_PANEL_GROUPS_HEADER`;
		this.nonGroupedItemsHeaderLocalizationKey = `${prefix}_PANEL_NON_GROUPED_ITEMS_HEADER`;
		this.addItemToGroupLocalizationKey = `${prefix}_PANEL_ADD_ITEM_TO_GROUP`;
	}
}
